import { render, staticRenderFns } from "./AdminGeneralSettings.vue?vue&type=template&id=df269376&scoped=true"
import script from "./AdminGeneralSettings.vue?vue&type=script&lang=js"
export * from "./AdminGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df269376",
  null
  
)

export default component.exports